{
  "decrease": "Snížit {fieldLabel}",
  "increase": "Zvýšit {fieldLabel}",
  "numberField": "Číselné pole"
}
